// @flow

import type {InvoiceState, Action} from '../types'

const initialState: InvoiceState = {
  invoice: null,
  itemsToInvoice: [],
  isProcessing: false,
  finaliseError: false,
}

const invoice = (state: InvoiceState = initialState, action: Action) => {
  switch (action.type) {
    case 'SET_INVOICE_FINALISE_ERROR':
      return {
        ...state,
        finaliseError: action.finaliseError,
      }
    case 'SET_INVOICE':
      return {
        ...state,
        invoice: action.invoice,
      }
    case 'SET_INVOICE_ITEMS_TO_INVOICE':
      return {
        ...state,
        itemsToInvoice: action.itemsToInvoice,
      }
    case 'SET_INVOICE_PROCESSING':
      return {
        ...state,
        isProcessing: action.isProcessing,
      }
    default:
      return state
  }
}

export default invoice
